import { defineMessages } from 'react-intl'

const translations = defineMessages({
  summaryTotalProducts: {
    defaultMessage: 'Total products',
    id: 'msp.account.order_history.order_detail.summary.products_total'
  },
  summaryShipping: {
    defaultMessage: 'Shipping costs',
    id: 'msp.account.order_history.order_detail.summary.shipping_total'
  },
  summaryVAT: {
    defaultMessage: 'VAT',
    id: 'msp.account.order_history.order_detail.summary.vat_total'
  },
  summaryPromos: {
    defaultMessage: 'Order Discounts',
    id: 'msp.account.order_history.order_detail.summary.discounts_total'
  },
  summaryOrderTotal: {
    defaultMessage: 'Total',
    id: 'msp.account.order_history.order_detail.summary.order_total'
  },
  summaryOrderVAT: {
    defaultMessage: '(incl. VAT)',
    id: 'msp.account.order_history.order_detail.summary.order_vat_included'
  }
})

export default translations
